import React, { useEffect, useState } from 'react';
import { Alert, Box, LinearProgress, Typography } from '@mui/material';

import { useTracking } from '../../../context/TrackingContext';
interface StripeConnectRedirectProps {
  redirectDelay?: number; // in seconds, default 5
  onCountdownComplete?: () => void;
  variant?: 'inline' | 'modal';
}

export const StripeConnectRedirect: React.FC<StripeConnectRedirectProps> = ({
  redirectDelay = 3,
  onCountdownComplete,
  variant = 'inline',
}) => {
  const [countdown, setCountdown] = useState<number>(redirectDelay);
  const { trackEvent } = useTracking();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0 && onCountdownComplete) {
      trackEvent('STRIPE_CONNECT_ONBOARDING_STARTED', {});
      onCountdownComplete();
    }
    return () => {
      clearTimeout(timer);
    };
  }, [countdown, onCountdownComplete, trackEvent]);

  const progress = ((redirectDelay - countdown) / redirectDelay) * 100;

  if (variant === 'modal') {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom align="center">
          You will be redirected to the Stripe onboarding page hosted by Stripe in {countdown}{' '}
          seconds
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ mt: 2, height: 8, borderRadius: 1 }}
        />
      </Box>
    );
  }

  // Inline variant
  return (
    <Alert severity="info" icon={false} sx={{ py: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1">Preparing Stripe connection...</Typography>
        <Typography variant="body2" color="text.secondary">
          You&apos;ll be redirected in {countdown} seconds
        </Typography>
      </Box>
      <LinearProgress variant="determinate" value={progress} sx={{ height: 6, borderRadius: 1 }} />
    </Alert>
  );
};
